module.exports = __webpack_public_path__ + "static/media/Лукащук С., Спеле В. (ДУ).fdad510c.pdf";